import SubCategoriesService3 from './SubCategoriesService3';

export {default} from './SubCategoriesService3';
export const subCategoriesService3 = new SubCategoriesService3();